// Accordion
import {
  Accordion as AccordionRoot,
  AccordionItem,
  AccordionTrigger,
  AccordionPanel,
  AccordionContent,
} from "./accordion"
export const Accordion = Object.assign(AccordionRoot, {
  Item: AccordionItem,
  Trigger: AccordionTrigger,
  Panel: AccordionPanel,
  Content: AccordionContent,
})

// Alert
export * from "./alert"

// Alert Dialog
import {
  AlertDialog as AlertDialogRoot,
  AlertDialogTrigger,
  AlertDialogPortal,
  AlertDialogClose,
  AlertDialogBackdrop,
  AlertDialogOverlay,
  AlertDialogPopup,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
} from "./alert-dialog"
export const AlertDialog = Object.assign(AlertDialogRoot, {
  Trigger: AlertDialogTrigger,
  Portal: AlertDialogPortal,
  Close: AlertDialogClose,
  Backdrop: AlertDialogBackdrop,
  Overlay: AlertDialogOverlay,
  Popup: AlertDialogPopup,
  Content: AlertDialogContent,
  Header: AlertDialogHeader,
  Footer: AlertDialogFooter,
  Title: AlertDialogTitle,
  Description: AlertDialogDescription,
})
export {
  AlertDialogTrigger,
  AlertDialogPortal,
  AlertDialogClose,
  AlertDialogBackdrop,
  AlertDialogOverlay,
  AlertDialogPopup,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
} from "./alert-dialog"

// Autocomplete
import {
  Autocomplete as AutocompleteRoot,
  AutocompleteInput,
  AutocompleteTrigger,
  AutocompleteClear,
  AutocompleteList,
  AutocompleteRow,
  AutocompleteValue,
} from "./autocomplete"
export const Autocomplete = Object.assign(AutocompleteRoot, {
  Input: AutocompleteInput,
  Trigger: AutocompleteTrigger,
  Clear: AutocompleteClear,
  List: AutocompleteList,
  Row: AutocompleteRow,
  Value: AutocompleteValue,
})

// Avatar
export * from "./Avatar"

// Badge
export * from "./badge"

// Breadcrumb
import {
  Breadcrumb as BreadcrumbRoot,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
  BreadcrumbEllipsis,
} from "./breadcrumb"
export const Breadcrumb = Object.assign(BreadcrumbRoot, {
  List: BreadcrumbList,
  Item: BreadcrumbItem,
  Link: BreadcrumbLink,
  Page: BreadcrumbPage,
  Separator: BreadcrumbSeparator,
  Ellipsis: BreadcrumbEllipsis,
})

// Button
export * from "./Button"

// Card
import {
  Card as CardRoot,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardPanel,
  CardContent,
} from "./card"
export const Card = Object.assign(CardRoot, {
  Header: CardHeader,
  Footer: CardFooter,
  Title: CardTitle,
  Action: CardAction,
  Description: CardDescription,
  Panel: CardPanel,
  Content: CardContent,
})

// Checkbox
export * from "./Checkbox"

// Checkbox Group
export * from "./checkbox-group"

// Collapsible
export * from "./collapsible"

// Combobox
import {
  Combobox as ComboboxRoot,
  ComboboxInput,
  ComboboxTrigger,
  ComboboxClear,
  ComboboxList,
  ComboboxRow,
  ComboboxValue,
} from "./combobox"
export const Combobox = Object.assign(ComboboxRoot, {
  Input: ComboboxInput,
  Trigger: ComboboxTrigger,
  Clear: ComboboxClear,
  List: ComboboxList,
  Row: ComboboxRow,
  Value: ComboboxValue,
})

// Dialog
import {
  Dialog as DialogRoot,
  DialogTrigger,
  DialogPortal,
  DialogClose,
  DialogBackdrop,
  DialogOverlay,
  DialogPopup,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from "./Dialog"
export const Dialog = Object.assign(DialogRoot, {
  Trigger: DialogTrigger,
  Portal: DialogPortal,
  Close: DialogClose,
  Backdrop: DialogBackdrop,
  Overlay: DialogOverlay,
  Popup: DialogPopup,
  Content: DialogPopup,
  Header: DialogHeader,
  Footer: DialogFooter,
  Title: DialogTitle,
  Description: DialogDescription,
})

// Empty
export * from "./empty"

// Field
import {
  Field as FieldRoot,
  FieldLabel,
  FieldDescription,
  FieldError,
  FieldControl,
  FieldValidity,
} from "./field"
export const Field = Object.assign(FieldRoot, {
  Label: FieldLabel,
  Description: FieldDescription,
  Error: FieldError,
  Control: FieldControl,
  Validity: FieldValidity,
})

// Fieldset
import {
  Fieldset as FieldsetRoot,
  FieldsetLegend,
} from "./fieldset"
export const Fieldset = Object.assign(FieldsetRoot, {
  Legend: FieldsetLegend,
})

// Form
export * from "./form"

// Flow Number
export * from "./flow-number"

// Frame
export * from "./frame"

// Group
export * from "./group"

// Input
export * from "./Input"

// Input Group
import {
  InputGroup as InputGroupRoot,
  InputGroupInput,
  InputGroupAddon,
  InputGroupText,
  InputGroupTextarea,
} from "./input-group"
export const InputGroup = Object.assign(InputGroupRoot, {
  Input: InputGroupInput,
  Addon: InputGroupAddon,
  Text: InputGroupText,
  Textarea: InputGroupTextarea,
})

// Kbd
export * from "./kbd"

// Label
export * from "./label"

// Menu
import {
  Menu as MenuRoot,
  MenuTrigger,
  MenuPortal,
  MenuPopup,
  MenuItem,
  MenuSeparator,
  MenuGroup,
  MenuGroupLabel,
  MenuSub,
  MenuSubTrigger,
  MenuSubPopup,
  MenuCheckboxItem,
  MenuRadioGroup,
  MenuRadioItem,
  MenuShortcut,
} from "./menu"
export const Menu = Object.assign(MenuRoot, {
  Trigger: MenuTrigger,
  Portal: MenuPortal,
  Popup: MenuPopup,
  Content: MenuPopup,
  Item: MenuItem,
  Separator: MenuSeparator,
  Group: MenuGroup,
  GroupLabel: MenuGroupLabel,
  Sub: MenuSub,
  SubTrigger: MenuSubTrigger,
  SubPopup: MenuSubPopup,
  SubContent: MenuSubPopup,
  CheckboxItem: MenuCheckboxItem,
  RadioGroup: MenuRadioGroup,
  RadioItem: MenuRadioItem,
  Shortcut: MenuShortcut,
})
export { Menu as DropdownMenu } from "./menu"

// Meter
export * from "./meter"

// Number Field
import {
  NumberField as NumberFieldRoot,
  NumberFieldGroup,
  NumberFieldIncrement,
  NumberFieldDecrement,
  NumberFieldInput,
} from "./number-field"
export const NumberField = Object.assign(NumberFieldRoot, {
  Group: NumberFieldGroup,
  Increment: NumberFieldIncrement,
  Decrement: NumberFieldDecrement,
  Input: NumberFieldInput,
})

// Pagination
import {
  Pagination as PaginationRoot,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationPrevious,
  PaginationNext,
  PaginationEllipsis,
} from "./pagination"
export const Pagination = Object.assign(PaginationRoot, {
  Content: PaginationContent,
  Item: PaginationItem,
  Link: PaginationLink,
  Previous: PaginationPrevious,
  Next: PaginationNext,
  Ellipsis: PaginationEllipsis,
})

// Popover
import {
  Popover as PopoverRoot,
  PopoverTrigger,
  PopoverPopup,
  PopoverContent,
} from "./Popover"
export const Popover = Object.assign(PopoverRoot, {
  Trigger: PopoverTrigger,
  Popup: PopoverPopup,
  Content: PopoverContent,
})

// Preview Card
import {
  PreviewCard as PreviewCardRoot,
  PreviewCardTrigger,
  PreviewCardPopup,
} from "./preview-card"
export const PreviewCard = Object.assign(PreviewCardRoot, {
  Trigger: PreviewCardTrigger,
  Popup: PreviewCardPopup,
  Content: PreviewCardPopup,
})
export { PreviewCard as HoverCard } from "./preview-card"

// Progress
export * from "./progress"

// Radio Group
import {
  RadioGroup as RadioGroupRoot,
  Radio,
  RadioGroupItem,
} from "./radio-group"
export const RadioGroup = Object.assign(RadioGroupRoot, {
  Item: RadioGroupItem,
})
export { Radio } from "./radio-group"

// Scroll Area
export * from "./scroll-area"

// Select
import {
  Select as SelectRoot,
  SelectTrigger,
  SelectValue,
  SelectPopup,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectGroup,
  SelectGroupLabel,
} from "./Select"
export const Select = Object.assign(SelectRoot, {
  Trigger: SelectTrigger,
  Value: SelectValue,
  Popup: SelectPopup,
  Content: SelectContent,
  Item: SelectItem,
  Separator: SelectSeparator,
  Group: SelectGroup,
  GroupLabel: SelectGroupLabel,
})

// Separator
export * from "./separator"

// Sheet
import {
  Sheet as SheetRoot,
  SheetTrigger,
  SheetPortal,
  SheetClose,
  SheetBackdrop,
  SheetOverlay,
  SheetPopup,
  SheetContent,
  SheetHeader,
  SheetFooter,
  SheetTitle,
  SheetDescription,
} from "./sheet"
export const Sheet = Object.assign(SheetRoot, {
  Trigger: SheetTrigger,
  Portal: SheetPortal,
  Close: SheetClose,
  Backdrop: SheetBackdrop,
  Overlay: SheetOverlay,
  Popup: SheetPopup,
  Content: SheetContent,
  Header: SheetHeader,
  Footer: SheetFooter,
  Title: SheetTitle,
  Description: SheetDescription,
})

// Skeleton
export * from "./skeleton"

// Slider
export * from "./Slider"

// Spinner
export * from "./spinner"

// Switch
export * from "./Switch"

// Table
import {
  Table as TableRoot,
  TableHeader,
  TableBody,
  TableFooter,
  TableRow,
  TableHead,
  TableCell,
  TableCaption,
} from "./table"
export const Table = Object.assign(TableRoot, {
  Header: TableHeader,
  Body: TableBody,
  Footer: TableFooter,
  Row: TableRow,
  Head: TableHead,
  Cell: TableCell,
  Caption: TableCaption,
})

// Tabs
import {
  Tabs as TabsRoot,
  TabsList,
  TabsTab,
  TabsTrigger,
  TabsPanel,
  TabsContent,
} from "./tabs"
export const Tabs = Object.assign(TabsRoot, {
  List: TabsList,
  Tab: TabsTab,
  Trigger: TabsTrigger,
  Panel: TabsPanel,
  Content: TabsContent,
})

// Textarea
export * from "./Textarea"

// Toast
// export * from "./toast"

// Toggle
export * from "./toggle"

// Toggle Group
import {
  ToggleGroup as ToggleGroupRoot,
  Toggle,
  ToggleGroupItem,
  ToggleGroupSeparator,
} from "./toggle-group"
export const ToggleGroup = Object.assign(ToggleGroupRoot, {
  Item: ToggleGroupItem,
  Separator: ToggleGroupSeparator,
})
export { Toggle as ToggleGroupToggle } from "./toggle-group"

// Toolbar
export * from "./toolbar"

// Tooltip
import {
  Tooltip as TooltipRoot,
  TooltipTrigger,
  TooltipPopup,
  TooltipContent,
} from "./Tooltip"
export const Tooltip = Object.assign(TooltipRoot, {
  Trigger: TooltipTrigger,
  Popup: TooltipPopup,
  Content: TooltipContent,
})

